import api from '@pray/shared/utils/api';

type DeleteArticleProps = {
  artistId: string;
  articleId: string;
};

export async function deleteArticle({ artistId, articleId }: DeleteArticleProps) {
  if (!artistId) throw Error('Artist ID is required');
  if (!articleId) throw Error('Article ID is required');

  await api.executeDeleteRequest(`/web/studio/artists/${artistId}/articles/${articleId}`);
}
